import Layout from '@/components/feature/Layout';
import ScrollReveal from '@/components/base/ScrollReveal';
import JsonLd from '@/components/base/JsonLd';
import { useTranslation } from 'react-i18next';

export default function PolitiqueConfidentialite() {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true }) as Array<Record<string, unknown>>;

  return (
    <Layout>
      <JsonLd data={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Politique de Confidentialité - IS TELECOM',
        description: 'Politique de confidentialité et protection des données personnelles d\'IS TELECOM. Collecte, utilisation, conservation, droits des utilisateurs, cookies.',
        url: 'https://is-telecom.co/politique-confidentialite',
        dateModified: '2026-08-03',
      }} />
      {/* Hero */}
      <section className="relative py-20 bg-background-950 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img src="https://readdy.ai/api/search-image?query=Abstract%20dark%20geometric%20security%20shield%20pattern%20with%20subtle%20blue%20and%20green%20accents%2C%20modern%20minimalist%20corporate%20background%20for%20privacy%20policy%20page%2C%20professional%20dark%20navy%20design%20with%20soft%20light%20shapes%20data%20protection%20concept&width=1920&height=600&seq=privacy-hero-01&orientation=landscape" alt="" className="w-full h-full object-cover" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-8">
          <h1 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">{t('privacy.heroTitle')}</h1>
          <p className="text-lg text-background-300 max-w-3xl mx-auto">
            {t('privacy.lastUpdated').replace('3 août 2026', '')}
          </p>
        </div>
      </section>

      {/* Content */}
      <ScrollReveal variant="fade-up">
      <section className="py-16 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none text-foreground-600 space-y-10">
            {sections.map((section, sIdx) => (
              <section key={sIdx}>
                <h2 className="text-2xl font-bold font-heading text-foreground-950 mb-4">{String(section.title || '')}</h2>
                {(section.paragraphs as string[] | undefined)?.map((p: string, pIdx: number) => (
                  <p key={pIdx} className="leading-relaxed" dangerouslySetInnerHTML={{ __html: p.replace(/IS TELECOM/g, '<strong class="text-foreground-950">IS TELECOM</strong>').replace(/is-telecom\.com/g, '<strong class="text-foreground-950">is-telecom.co</strong>') }} />
                ))}
                {(section.list as string[] | undefined) && (
                  <ul className="list-disc pl-6 mt-3 space-y-1.5">
                    {(section.list as string[]).map((item: string, lIdx: number) => (
                      <li key={lIdx}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}

            {/* Contact info block */}
            {sections.length > 0 && (
              <div className="mt-4 p-6 bg-background-100 rounded-2xl border border-background-200/70">
                <p className="text-foreground-950 font-semibold">IS TELECOM — Délégué à la Protection des Données</p>
                <p className="text-foreground-600">Adresse : Cotonou, Bénin</p>
                <p className="text-foreground-600">Téléphone : <a href="tel:+2290195892755" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">+229 01 95 89 27 55</a></p>
                <p className="text-foreground-600">Email : <a href="mailto:contact@is-telecom.co" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">contact@is-telecom.co</a></p>
              </div>
            )}
          </div>
        </div>
      </section>
      </ScrollReveal>
    </Layout>
  );
}